import { Divider } from "@mui/material";
import FlexBox from "components/common/FlexBox";
import FormHeader from "./FormHeader";
import { FormStructure } from "./FormRenderer";
import { useListFormResults } from "services/documents";
import { useEffect, useState } from "react";
import { Document } from "protogen/documents_pb";
import DocumentsTable from "components/documents/DocumentsTable";

export default ({
  document,
  form,
  uuid,
  mode,
  viewMode,
  setViewMode,
  additionalOptions,
}: {
  document: Document;
  form: FormStructure;
  uuid: string;
  mode: "create" | "view" | "complete";
  viewMode: "edit" | "view" | "results";
  setViewMode: (mode: "edit" | "view" | "results") => void;
  additionalOptions: React.ReactNode;
}) => {
  const [results, setResults] = useState<Document[]>([]);

  const { request: listFormResultsRequest } = useListFormResults();

  const loadFormResults = async () => {
    if (!document?.uuid) return;
    const r = await listFormResultsRequest({
      documentUUID: document.uuid,
    });
    setResults(r?.documents || []);
  };

  useEffect(() => {
    loadFormResults();
  }, [document]);

  return (
    <FlexBox direction="column" alignItems="unset" gap="24px">
      <FormHeader
        title={form.title}
        description={form.description}
        uuid={uuid}
        editable={false}
        showViewModeToggle={mode === "create" && !!viewMode && !!setViewMode}
        viewMode={viewMode}
        setViewMode={setViewMode}
        additionalOptions={additionalOptions}
        showCopyLink={mode === "create" || (mode === "view" && !!viewMode)}
      />
      <Divider />
      <DocumentsTable documents={results} layout="simple" formResults={true} />
    </FlexBox>
  );
};
